/* global XMLHttpRequest */
export default XMLHttpRequest;
